module.exports = __webpack_public_path__ + "img/withRng.1dca4a50.png";